import { Controller } from "@hotwired/stimulus"
import $ from "jquery"
import Modal from "bootstrap/js/dist/modal"

export default class extends Controller {
  open(event) {
    const fixtureId = event.currentTarget.dataset.fixtureId
    if (!fixtureId) return

    $.get(`/backend/fixtures/${fixtureId}/result`, (html) => {
      $('#fixture-result-modal .partial[data-id="fixture-result-form"]').html(html)
      Modal.getOrCreateInstance(document.getElementById('fixture-result-modal')).show()
    })
  }

  // Bound via data-action="modal-form:success@document->fixture-result#reloadList".
  // The fixtures table is now server-rendered, so the simplest way to reflect
  // a saved result is a full reload rather than patching the DOM in place.
  reloadList(event) {
    if (event.target.id !== 'fixture-result-modal') return

    window.location.reload()
  }
}
